import { useNavigate } from "react-router-dom";

// Illustrative preview of a migration in flight. These numbers are a static
// product visualization (not live data) — the real live scoreboard streams once
// a migration runs. Labeled honestly as a preview.
const PREVIEW_CHANNELS = [
  { name: "#general", pct: 100 },
  { name: "#engineering", pct: 82, live: true },
  { name: "#design", pct: 64, live: true },
  { name: "#watercooler", pct: 28 },
];

export function Hero() {
  const navigate = useNavigate();
  return (
    <section className="container hero" id="top">
      <div className="hero-copy">
        <div className="hero-badges">
          <span className="pill">
            <span className="dot-live" /> Discord is free
          </span>
          <span className="pill">Your history, preserved</span>
        </div>
        <h1 className="h-hero">
          Don’t cancel your Slack.{" "}
          <span className="gradient-text">Migrate it.</span>
        </h1>
        <p className="lede">
          Move every message, thread, and file into Discord — which is free —
          and keep the record your team built. Bring your whole history along,
          then leave the per-seat bill behind.
        </p>
        <div className="hero-cta">
          <button className="btn btn-primary" onClick={() => navigate("/pricing")}>
            Estimate your migration
          </button>
          <button className="btn btn-ghost" onClick={() => navigate("/how-it-works")}>
            See how it works
          </button>
        </div>
        <p className="hero-note">
          Invite the bot → watch it move → done. No bot-building, no token pasting.
        </p>
      </div>

      <div className="conduit" aria-label="Migration in progress — preview">
        <div className="conduit-rail">
          <div className="pole pole-slack">
            <span className="pole-badge">S</span>
            <span className="pole-label">Slack</span>
          </div>
          <div className="bridge" aria-hidden="true">
            <span className="bridge-line" />
            <span className="chip" />
            <span className="chip" />
            <span className="chip" />
            <span className="chip" />
          </div>
          <div className="pole pole-discord">
            <span className="pole-badge">D</span>
            <span className="pole-label">Discord</span>
          </div>
        </div>

        <div className="score">
          <div className="score-head">
            <span>MIGRATION · PREVIEW</span>
            <span>
              <span className="dot-live" style={{ display: "inline-block" }} />{" "}
              streaming
            </span>
          </div>
          {PREVIEW_CHANNELS.map((c) => (
            <div className="score-row" key={c.name}>
              <span className="score-name">{c.name}</span>
              <span className={`meter${c.live ? " animate" : ""}`}>
                <span style={{ width: `${c.pct}%` }} />
              </span>
              <span className="score-pct">{c.pct}%</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
